import React from 'react'
import './Portfolio.css'

export default function Portfolio() {
  return (
    <div className="portfolio-cont">
        <div className="projt-row">
          <div className="projt-wrap">
            <div className="projet-img-cont"> 
                <img src={require('./galerie/todo.png')} className="projet-img"/>
            </div>
            <div className="descr-cont">
                <div className="descr">
                  <a href='https://earnest-blancmange-50979e.netlify.app/' target='blanck'>
                    ToDo Tasks App</a>
                </div>
              </div>
          </div>
        <div className="projt-wrap">
          <div className="projet-img-cont"> 
              <img src={require('./galerie/starb.png')} className="projet-img"/>
          </div>
          <div className="descr-cont">
              <div className="descr"><a href='https://graceful-churros-0b4e2e.netlify.app/'>StarBucks Landpage</a></div>
            </div>
        </div>
        </div>
        <div className="projt-row">
          <div className="projt-wrap">
          <div className="projet-img-cont"> 
              <img src="https://propertywiselaunceston.com.au/wp-content/themes/property-wise/images/no-image.png" className="projet-img"/>
          </div>
          <div className="descr-cont">
              <div className="descr">Title Description</div>
            </div>
        </div>
          <div className="projt-wrap">
          <div className="projet-img-cont"> 
              <img src="https://propertywiselaunceston.com.au/wp-content/themes/property-wise/images/no-image.png" className="projet-img"/>
          </div>
          <div className="descr-cont">
              <div className="descr">Title Description</div >
            </div>
        </div>
          <div className="projt-wrap">
          <div className="projet-img-cont"> 
              <img src="https://propertywiselaunceston.com.au/wp-content/themes/property-wise/images/no-image.png" className="projet-img"/>
          </div>
          <div className="descr-cont">
              <div className="descr">Title Description</div >
            </div>
        </div>
        </div>
    </div>
  )
}
